/* ============================================================
   footer-kinetic.js — TAPS editorial mega-brand footer motion.
   Mask-reveal of the wide logo, staggered grid rise, rule draws,
   scrubbed ghost-chevron drift. Final states = CSS defaults, so
   no-JS / reduced-motion users see everything.
   ============================================================ */
(function () {
  function init() {
    var root = document.querySelector('.ftk-foot');
    if (!root || root.__ftk) return;
    root.__ftk = true;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var g = window.gsap;
    if (!g || reduced) return;
    var ST = window.ScrollTrigger;
    if (ST && g.registerPlugin) g.registerPlugin(ST);

    var logo = root.querySelector('.ftk-mega-logo');
    var eyebrows = root.querySelectorAll('.ftk-wrap > .ftk-eyebrow');
    var gridItems = root.querySelectorAll('.ftk-grid > *');
    var rules = root.querySelectorAll('.ftk-rule');
    var news = root.querySelector('.ftk-news');
    var legal = root.querySelector('.ftk-legal');
    var ghost = root.querySelector('.ftk-ghost-svg');

    /* initial (hidden) states set via JS only */
    if (logo) g.set(logo, { yPercent: 114, rotate: 1.5, transformOrigin: '0% 100%' });
    if (eyebrows.length) g.set(eyebrows, { y: 14, autoAlpha: 0 });
    if (gridItems.length) g.set(gridItems, { y: 36, autoAlpha: 0 });
    if (rules.length) g.set(rules, { scaleX: 0, transformOrigin: '0% 50%' });
    if (news) g.set(news, { y: 24, autoAlpha: 0 });
    if (legal) g.set(legal, { y: 12, autoAlpha: 0 });

    var tl = g.timeline({ paused: true, defaults: { ease: 'power4.out' } });
    tl.to(eyebrows, { y: 0, autoAlpha: 1, duration: 0.6 }, 0);
    if (logo) tl.to(logo, { yPercent: 0, rotate: 0, duration: 1.15 }, 0.05);
    tl.to(rules, { scaleX: 1, duration: 1.0 }, 0.55)
      .to(gridItems, { y: 0, autoAlpha: 1, duration: 0.9, stagger: 0.09 }, 0.6)
      .to(news, { y: 0, autoAlpha: 1, duration: 0.8 }, 1.0)
      .to(legal, { y: 0, autoAlpha: 1, duration: 0.8 }, 1.15);

    if (ST) {
      ST.create({ trigger: root, start: 'top 82%', once: true, onEnter: function () { tl.play(); } });
      if (ghost) {
        g.fromTo(ghost,
          { yPercent: 16, xPercent: 4, rotate: -4 },
          { yPercent: -16, xPercent: 0, rotate: 3, ease: 'none',
            scrollTrigger: { trigger: root, start: 'top bottom', end: 'bottom top', scrub: 1.2 } });
      }
      window.addEventListener('load', function () { ST.refresh(); });
    } else if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { tl.play(); io.disconnect(); break; }
        }
      }, { threshold: 0.15 });
      io.observe(root);
    } else { tl.play(); }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
